import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Crumbs } from "../components/Bits";
import { Head } from "../components/Head";
import { API, store } from "../lib/util";
import { AiCard, MatchCard } from "./Fridge";

const GONE = "Forslaget findes ikke længere";

function Gone() {
  return (
    <div className="ptop" data-testid="fridge-share-missing">
      <h1>{GONE}</h1>
      <p className="lead">Linket er udløbet eller forkert. Du kan selv skrive, hvad du har i køleskabet, og få nye forslag.</p>
      <p><a className="btn" href="/koeleskabet/" data-testid="fridge-share-missing-link">Gå til Køleskabet</a></p>
    </div>
  );
}

export default function FridgeShare() {
  const { id } = useParams();
  const nav = useNavigate();
  const [d, setD] = useState(undefined);
  useEffect(() => {
    let live = true;
    fetch(`${API}/fridge/share/${encodeURIComponent(id)}`).then(r => (r.ok ? r.json() : null)).catch(() => null).then(x => { if (live) setD(x); });
    return () => { live = false; };
  }, [id]);
  const tryIt = () => { store.set("fridge", ""); nav("/koeleskabet/"); };
  const ai = d?.ai;
  return (
    <>
      <Head title="Aftensmad ud fra mit køleskab | Hverdagsmaden" brand={false} path={`koeleskabet/del/${id}/`} noindex
        desc="Forslag til aftensmad ud fra det, der er i køleskabet. Se opskrifterne på Hverdagsmaden." />
      <Crumbs trail={[["koeleskabet/", "Køleskabet"], [null, "Delt forslag"]]} />
      <div className="wrap" data-testid="fridge-share-page">
        {d === undefined && <div className="fr-loading" data-testid="fridge-share-loading"><span className="fr-spin" />Henter forslaget…</div>}
        {d === null && <Gone />}
        {d && (
          <>
            <div className="ptop"><h1>Aftensmad ud fra mit køleskab</h1>
              <p className="lead">Nogen har delt deres forslag med dig. Sådan så køleskabet ud:</p>
              <div className="fr-chips fr-shared-ings" data-testid="fridge-share-ingredients">{d.terms.map(t => <span key={t} className="fchip" aria-pressed="true">{t}</span>)}</div>
              <div className="fr-share">
                <p>Har du noget andet i køleskabet?</p>
                <button className="btn" type="button" onClick={tryIt} data-testid="fridge-share-try-button">Prøv selv</button>
              </div>
            </div>
            {ai?.status !== "non_food" && (
              <section className="fr-sec" data-testid="fridge-share-matches">
                <div className="sh"><h2>Opskrifter du kan lave</h2></div>
                {d.matches.length ? <div className="fr-grid">{d.matches.map(m => <MatchCard key={m.recipe.slug} m={m} r={m.recipe} />)}</div>
                  : <p className="fr-empty" data-testid="fridge-share-no-matches">Ingen opskrifter på siden passer godt til det, du har.</p>}
              </section>
            )}
            {ai && ai.status !== "non_food" && (
              <section className="fr-sec" data-testid="fridge-share-ai">
                <div className="sh"><h2>AI-forslag</h2></div>
                {ai.status === "ok" && <div className="fr-ailist">{ai.recipes.map((x, i) => <AiCard key={i} x={x} i={i} />)}</div>}
                {ai.status === "unavailable" && <p className="note">{ai.message}</p>}
              </section>
            )}
            {ai?.status === "non_food" && <p className="fr-msg" role="alert">{ai.message}</p>}
            {!ai && d.needs_ai && <p className="note" data-testid="fridge-share-ai-pending">AI-forslagene var ikke færdige, da linket blev delt.</p>}
          </>
        )}
      </div>
    </>
  );
}
